module.exports = __webpack_public_path__ + "static/img/m6.c1e1056.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/mobile/m6.png
// module id = iCuY
// module chunks = 12